import React, { Component } from 'react';

import Button from '../../common/Button/Button';
import randomHouse from '../../../assets/images/random_house.svg';

import styles from './FormInvite.scss';
import cn from 'classnames/bind';
const cx = cn.bind( styles );

import { reduxForm, Field } from 'redux-form';

class FormInvite extends Component {

  onSubmit=(data)=>{
    const {dispatch, inviteFormSending} = this.props;
    dispatch( inviteFormSending( data ) );
  };

  renderField = ({meta, input, placeholder})=>(
    <div className={cx( styles.InnerInput, { FormError: meta.touched && meta.invalid } )}>
      <input className={styles.Input} placeholder={placeholder} {...input}/>
      {meta.touched && meta.error && <div className={null}>{meta.error}</div>}
    </div>);

  render() {
    const { handleSubmit, className } = this.props;


    return (
      <form onSubmit={handleSubmit( this.onSubmit )}>
        <div className={cn( styles.FormInvite, className )}>
          <div className={styles.Top}>
            <div className={styles.Left}>
              <div className={styles.Title}>
                Заявка на получение приглашения
              </div>

              <div className={styles.Image}>
                <img alt="house" src={randomHouse} />
              </div>
            </div>

            <div className={styles.Right}>
              <Field type="text" name="firstName" component={this.renderField} placeholder='Ваше имя'/>
              <Field type="text" name="lastName" component={this.renderField} placeholder='Ваша фамилия'/>
              <Field type="text" name="company" component={this.renderField} placeholder='Компания'/>
              <Field type="text" name="position" component={this.renderField} placeholder='Должность'/>
              <Field type="text" name="number" component={this.renderField} placeholder='Телефон'/>
            </div>

          </div>

          <div className={styles.Bottom}>
            <Button className={styles.Enter}> Войти на сайт </Button>
            <Button type="submit" className={styles.Button}>Оставить заявку</Button>
          </div>

        </div>
      </form>
    );
  }
}

function validate( values ) {
  const errors = {};

  if ( !values.firstName ) {
    errors.firstName = 'Это поле нельзя оставлять пустым';
  }

  if ( !values.lastName ) {
    errors.lastName = 'Это поле нельзя оставлять пустым';
  }

  if ( !values.company ) {
    errors.company = 'Это поле нельзя оставлять пустым';
  }

  if ( !values.position ) {
    errors.position = 'Это поле нельзя оставлять пустым';
  }

  if ( !values.number ) {
    errors.number = 'Это поле нельзя оставлять пустым';
  }

  return errors;
}

export default FormInvite = reduxForm( {
  form: 'formInvite',
  // fields: [ 'firstName', 'lastName', 'company', 'position', 'number' ],
  validate
}, null, null )( FormInvite );



// WEBPACK FOOTER //
// ./src/components/Login/FormInvite/FormInvite.js